module.exports = __webpack_public_path__ + "static/media/one-hour-later.31533ab9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/modern-javascript/assets/one-hour-later.jpg
// module id = 1540
// module chunks = 0